import { render, staticRenderFns } from "./PowerUpKeys.vue?vue&type=template&id=2aeea3d1&scoped=true&"
import script from "./PowerUpKeys.vue?vue&type=script&lang=js&"
export * from "./PowerUpKeys.vue?vue&type=script&lang=js&"
import style0 from "./PowerUpKeys.vue?vue&type=style&index=0&id=2aeea3d1&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeea3d1",
  null
  
)

export default component.exports